import type { ReactNode } from "react";

export function ChainOfThought({ title, children }: { title: string; children: ReactNode }) {
  return (
    <details className="pk-chain">
      <summary>{title}</summary>
      <div className="pk-chain-content">{children}</div>
    </details>
  );
}

export function ChainOfThoughtItem({ children }: { children: ReactNode }) {
  return <div className="pk-chain-item">{children}</div>;
}
